import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import styles from './styles.scss';
class Input extends React.Component {
  render() {
    const {
      value,
      dataHook,
      className,
      disabled,
      onChange,
      onFocus,
      onBlur,
      setRef,
      tabIndex,
      ariaLabel
    } = this.props;
    return /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: styles.input + " " + className,
      "data-hook": dataHook,
      ref: setRef,
      "aria-label": ariaLabel,
      value: value,
      tabIndex: tabIndex,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      disabled: disabled
    });
  }
}
_defineProperty(Input, "defaultProps", {
  // TODO
  // Warning: Failed prop type: You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.
  onChange: () => {} // placeholder for onChange to prevent warning
});

export default Input;
//# sourceMappingURL=input.js.map